import React from 'react';
import './css/PartnerRegistration.css';

import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

import PartnerRegistrationHeroBg from '../images/HomeBgBanner.png';

import featureSectionBg2 from '../images/Banner3.png';

import {
    FaBullseye,
    FaHandshake,
    FaShieldAlt,
    FaHeart,
    FaUsers,
    FaUserCog,
    FaClipboardCheck,
    FaLaptopCode
} from "react-icons/fa";

import DownloadApp from './components/DownloadApp';

function PartnerRegistration() {

    return (
        <div className="PartnerRegistration-page-wrapper">

            {/* 1. Header Hero Section */}
            <section
                className="PartnerRegistration-hero-section"
                style={{ backgroundImage: `url(${PartnerRegistrationHeroBg})` }}
            >
                <Navbar />
            </section>



            {/* 2. How to Join as a Fixovera Partner */}
            <section className="PartnerRegistration-flow-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>

                <div className="container">

                    {/* Section Header */}
                    <div className="PartnerRegistration-flow-header">

                        <span className="PartnerRegistration-flow-tag">
                            BECOME A FIXOVERA PARTNER
                        </span>

                        <h2 className="PartnerRegistration-flow-heading">
                            How to Join Fixovera as a Service Partner
                        </h2>

                        <p className="PartnerRegistration-flow-subtext">
                            Joining Fixovera is simple. Complete your registration,
                            submit your verification documents, complete the verification
                            process, and start receiving home service orders through your
                            personalized partner dashboard.
                        </p>

                        <div className="PartnerRegistration-flow-zigzag"></div>

                    </div>


                    {/* Partner Journey */}
                    <div className="PartnerRegistration-flow-container">

                        <div className="row g-4">

                            {/* Step 1 */}
                            <div className="col-lg-4 col-md-6">

                                <div className="PartnerRegistration-flow-card">

                                    <div className="PartnerRegistration-flow-number">
                                        1
                                    </div>

                                    <div className="PartnerRegistration-flow-icon">
                                        <FaUsers />
                                    </div>

                                    <h4>
                                        Create Your Account
                                    </h4>

                                    <p>
                                        Start your partner registration by providing
                                        your basic contact details and creating your
                                        Fixovera partner account.
                                    </p>

                                </div>

                            </div>


                            {/* Step 2 */}
                            <div className="col-lg-4 col-md-6">

                                <div className="PartnerRegistration-flow-card">

                                    <div className="PartnerRegistration-flow-number">
                                        2
                                    </div>

                                    <div className="PartnerRegistration-flow-icon">
                                        <FaUserCog />
                                    </div>

                                    <h4>
                                        Mobile Verification
                                    </h4>

                                    <p>
                                        Verify your registered mobile number using the
                                        OTP sent to your phone to continue the
                                        registration process.
                                    </p>

                                </div>

                            </div>


                            {/* Step 3 */}
                            <div className="col-lg-4 col-md-6">

                                <div className="PartnerRegistration-flow-card">

                                    <div className="PartnerRegistration-flow-number">
                                        3
                                    </div>

                                    <div className="PartnerRegistration-flow-icon">
                                        <FaClipboardCheck />
                                    </div>

                                    <h4>
                                        Submit ID Documents
                                    </h4>

                                    <p>
                                        Upload the required identity documents such as
                                        Aadhaar Card, PAN Card or Voter ID for your
                                        partner verification.
                                    </p>

                                </div>

                            </div>


                            {/* Step 4 */}
                            <div className="col-lg-4 col-md-6">

                                <div className="PartnerRegistration-flow-card">

                                    <div className="PartnerRegistration-flow-number">
                                        4
                                    </div>

                                    <div className="PartnerRegistration-flow-icon">
                                        <FaShieldAlt />
                                    </div>

                                    <h4>
                                        Police Verification
                                    </h4>

                                    <p>
                                        Fixovera's verification team reviews the
                                        submitted information and completes the
                                        required police verification process.
                                    </p>

                                </div>

                            </div>


                            {/* Step 5 */}
                            <div className="col-lg-4 col-md-6">

                                <div className="PartnerRegistration-flow-card">

                                    <div className="PartnerRegistration-flow-number">
                                        5
                                    </div>

                                    <div className="PartnerRegistration-flow-icon">
                                        <FaHandshake />
                                    </div>

                                    <h4>
                                        Partner Approval
                                    </h4>

                                    <p>
                                        Once the verification process is successfully
                                        completed, the Fixovera admin team marks your
                                        account as an approved service partner.
                                    </p>

                                </div>

                            </div>


                            {/* Step 6 */}
                            <div className="col-lg-4 col-md-6">

                                <div className="PartnerRegistration-flow-card final-step">

                                    <div className="PartnerRegistration-flow-number">
                                        6
                                    </div>

                                    <div className="PartnerRegistration-flow-icon">
                                        <FaLaptopCode />
                                    </div>

                                    <h4>
                                        Activate Your Wallet & Get Orders
                                    </h4>

                                    <p>
                                        Access your personalized partner dashboard,
                                        recharge your Fixovera wallet, and become
                                        eligible to receive service orders.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>


                    {/* Wallet Explanation */}
                    <div className="PartnerRegistration-wallet-note">

                        <h4>
                            💳 Why Do I Need to Recharge My Wallet?
                        </h4>

                        <p>
                            After your partner account is approved, you need to maintain
                            sufficient balance in your Fixovera wallet to receive orders.
                            Once your wallet is recharged, your account is ready to
                            receive eligible service orders through the Fixovera platform.
                        </p>

                    </div>

                </div>

            </section>


           

            {/* Download App Section */}
            <DownloadApp />


            {/* Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default PartnerRegistration;